import type { SearchModes } from '@/domainLogic/index.ts';
import type { AccData } from '@/app/common/memsearch/typesAccData.ts';
import type { Dates } from '@/app/components/search/utils';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { SearchParams } from '@/server/searchParams.ts';
import type { SearchInfoDetailData } from '@/app/search/types.ts';
import getSubTitle from '../../common/getSubTitle';
import getTitle from '../../common/getTitle';
import type { Localization } from '../../common/Localization';

type GetTitleProps = {
  searchParams: SearchParams;
  searchMode: SearchModes;
  searchInfoDetailData: SearchInfoDetailData;
  searchDates: Dates;
  dealsCount: number;
  localization: Localization;
  isMobile: boolean;
  hasPreselectedFlight: boolean;
  showCustomCheckinCheckout: boolean;
  accData?: AccData;
  t: TranslationFunction;
};
const getTitleProps = ({
  searchParams,
  searchMode,
  searchInfoDetailData,
  searchDates,
  dealsCount,
  localization,
  isMobile,
  showCustomCheckinCheckout,
  accData,
  t,
}: GetTitleProps) => {
  const destinationDescription = searchInfoDetailData?.destination?.description;
  const title = getTitle({
    searchParams,
    t,
    searchMode,
    searchInfoDetailData,
  });
  const subTitle = getSubTitle({
    searchDates,
    dealsCount,
    isMobile,
    showCustomCheckinCheckout,
    accData,
    localization,
    t,
  });
  const loadingTitle = destinationDescription
    ? t('vacation.oss.waiting.searching_best_deals', {
        placeholder: `${destinationDescription}`,
      })
    : null;

  return {
    text: title,
    subTitle,
    loadingTitle,
  };
};

export default getTitleProps;
